import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SmsSettingCreateSmsSetting,
  SmsSettingFilterSmsSetting,
  SmsSettingUpdateSmsSetting,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function SmsSettingAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const SmsSettingFilterSmsSettingData = await SmsSettingFilterSmsSetting(
          {
            id: id,
          }
        );
        if (
          SmsSettingFilterSmsSettingData.status &&
          SmsSettingFilterSmsSettingData.status === 200
        ) {
          setForm(SmsSettingFilterSmsSettingData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.address === "") {
      toast.error("Address را وارد نمایید ");
      validation = false;
    }
    if (form.userName === "") {
      toast.error("UserName را وارد نمایید ");
      validation = false;
    }
    if (form.password === "") {
      toast.error("Password را وارد نمایید ");
      validation = false;
    }
    if (form.token === "") {
      toast.error("Token را وارد نمایید ");
      validation = false;
    }
    if (form.isShair === "") {
      toast.error("IsShair را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const SmsSettingUpdateSmsSettingData =
            await SmsSettingUpdateSmsSetting(form);
          if (
            SmsSettingUpdateSmsSettingData.status &&
            SmsSettingUpdateSmsSettingData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/SmsSetting");
          }
        } else {
          const SmsSettingCreateSmsSettingData =
            await SmsSettingCreateSmsSetting(form);
          if (
            SmsSettingCreateSmsSettingData.status &&
            SmsSettingCreateSmsSettingData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/SmsSetting");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="address"
                id="address"
                text="Address"
                className="m-2"
                value={form.address || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="userName"
                id="userName"
                className="m-2"
                text="User Name"
                value={form.userName || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="password"
                id="password"
                className="m-2"
                text="Password"
                value={form.password || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="token"
                id="token"
                className="m-2"
                text="Token"
                value={form.token || ""}
                onChange={handleChangeSearch}
              />
              <Select
                className="m-2"
                name="isShair"
                id="isShair"
                text="Is Shair"
                value={form.isShair || ""}
                onChange={handleChangeSearch}
                option={[
                  { value: true, title: "بله" },
                  { value: false, title: "خیر" },
                ]}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmsSettingAE;
